export enum Status {
  Success = 'success',
  Failed = 'failed',
}

export enum BusinessPage {
  LoginByPassword = 'login_by_password',
  LoginByOtp = 'login_by_otp',
  SignupByOtp = 'signup_by_otp',
  LoginByOtpOneCredential = 'login_by_otp_one_credential',
  LoginByPasswordOneCredential = 'login_by_password_one_credential',
  SignupByOtpOneCredential = 'signup_by_otp_one_credential',
  LoginByOtpOneCredentialOptional = 'login_by_otp_one_credential_optional',
  LoginByPasswordOneCredentialOptional = 'login_by_password_one_credential_optional',
  SignupByOtpOneCredentialOptional = 'signup_by_otp_one_credential_optional',
  LoginByToken = 'login_by_token',
  Relogin = 'relogin',
  LoginByIvs = 'login_by_ivs',
  ResetPassword = 'reset_password',
  LoginByNoCostAuthentication = 'login_by_no_cost_authentication',
}

export enum LoginMethod {
  PhoneOtp = 'phone_otp',
  EmailOtp = 'email_otp',
  Password = 'password',
  Google = 'google',
  Apple = 'apple',
  Facebook = 'facebook',
  Shopee = 'shopee',
  Biometric = 'biometric',
  QuickLogin = 'quicklogin',
  TokenOtp = 'token_otp',
}

export enum SignupMethod {
  Phone = 'phone',
  Email = 'email',
}

export enum AccType {
  TocOneCredential = 'toc_one_credential',
  Tob = 'tob',
}

export enum PostAuthUnexpectedBehaviorReason {
  ProcessStop = 'process_stop', // Signal.Stop emitted
  ErrorZeroButDataMissing = 'error_zero_but_data_missing', // Post Authentication is triggered with no error but key data is missing
  NeedIvsTokenMissing = 'need_ivs_token_missing', // error === ErrorCode.NeedIvs but `uToken` or `ivsFlowNo` is missing
  ApiFailed = 'api_failed', // An API call in the post-authentication completion path failed
}
